export const COLOR_LINE = '#333333';
export const COLOR_PANEL_1 = '#660033';
export const COLOR_PANEL_2 = '#004466';
export const COLOR_PANEL_3 = '#FFFFFF';
export const COLOR_PANEL_4 = '#111111';
export const COLOR_PANEL_5 = '#444444';
export const COLOR_PANEL_6 = '#888888';
export const COLOR_SELECT = '#7fed7f';
export const COLOR_SELECT2 = '#148d14';
export const COLOR_RED = '#E60073';
export const COLOR_BLUE = '#0099E6';
export const COLOR_RED2 = '#E60073';
export const COLOR_BLUE2 = '#0099E6';
export const COLOR_WHITE = '#FFFFFF';
export const PIECES = {
    '1': [1, 1, 1,
        1, 0, 1,
        1, 1, 1],
    '2': [1, 1, 1,
        1, 0, 1,
        1, 0, 1],
    '3': [1, 1, 1,
        0, 0, 0,
        1, 1, 1],
    '4': [1, 1, 1,
        0, 0, 0,
        1, 0, 1],
    '5': [1, 0, 1,
        0, 0, 0,
        1, 0, 1],
    '6': [1, 0, 1,
        0, 0, 0,
        0, 1, 0],
    '7': [0, 1, 0,
        0, 0, 0,
        0, 1, 0],
    '8': [0, 1, 0,
        0, 0, 0,
        0, 0, 0],
    '-1': [1, 1, 1,
        1, 0, 1,
        1, 1, 1],
    '-2': [1, 0, 1,
        1, 0, 1,
        1, 1, 1],
    '-3': [1, 1, 1,
        0, 0, 0,
        1, 1, 1],
    '-4': [1, 0, 1,
        0, 0, 0,
        1, 1, 1],
    '-5': [1, 0, 1,
        0, 0, 0,
        1, 0, 1],
    '-6': [0, 1, 0,
        0, 0, 0,
        1, 0, 1],
    '-7': [0, 1, 0,
        0, 0, 0,
        0, 1, 0],
    '-8': [0, 0, 0,
        0, 0, 0,
        0, 1, 0]
};
